import BadgeLegend from "./components/badge-legend";
import { Link } from "react-router-dom";
import PredefinedBadge from "./components/predefined-badge";
import React from "react";

export function getSmallBadges(tournament, showFeatured, showGameType) {
  var badges = [];

  if (tournament.get("featured") && showFeatured) {
    badges.push(<PredefinedBadge key="featured" type="featured" />);
  }
  if (tournament.get("tournament_type") === "Round" && showGameType) {
    badges.push(<PredefinedBadge key="classic" type="classic" />);
  }
  if (tournament.get("tournament_type") === "Survivor" && showGameType) {
    badges.push(<PredefinedBadge key="survivor" type="survivor" />);
  }
  if (tournament.get("number_of_users_required") <= 1) {
    badges.push(<PredefinedBadge key="guaranteed" type="guaranteed" />);
  }
  if (tournament.get("real_money")) {
    badges.push(<PredefinedBadge key="real-money" type="real-money" />);
  }
  if (tournament.get("lockdown")) {
    badges.push(<PredefinedBadge key="lockdown" type="lockdown" />);
  }
  if (tournament.get("parent_id") || tournament.get("qualifier")) {
    badges.push(<PredefinedBadge key="qualifier" type="qualifier" />);
  }

  return badges;
}

export function getLargeBadges(tournament, showFeatured, showGameType, firstRace) {
  var badges = [];

  var runnerLabel = "horse";

  if (typeof firstRace !== "undefined" && firstRace.get("track_breed_type") === "Greyhound") {
    runnerLabel = "greyhound";
  }

  if (tournament.get("featured") && showFeatured) {
    badges.push(
      <BadgeLegend color="dark-lime" icon="star" key="featured" text="Featured Game">
        Highlighted Tournament!
      </BadgeLegend>
    );
  }
  if (tournament.get("tournament_type") === "Round" && showGameType) {
    badges.push(
      <BadgeLegend color="black" icon="horseshoe-solid" key="classic" text="Classic Game">
        Pick one
        { " " + runnerLabel + " "}
        per race. Scoring based on $2

        {tournament.get("bet_type")}
        .
      </BadgeLegend>
    );
  }
  if (tournament.get("tournament_type") === "Survivor" && showGameType) {
    badges.push(
      <BadgeLegend color="black" icon="survivor" key="survivor" text="Survivor Game">
        Single elimination. Finish 1st, 2nd or 3rd to advance.
      </BadgeLegend>
    );
  }
  if (tournament.get("number_of_users_required") <= 1) {
    badges.push(
      <BadgeLegend color="purple" icon="checkmark4" key="guaranteed" text="Guaranteed Game">
        No minimum amount of players required.
      </BadgeLegend>
    );
  }
  if (tournament.get("real_money")) {
    badges.push(
      <BadgeLegend color="lime" icon="real-money" key="real-money" text="Live Bankroll Game">
        Live Bankroll Contests &amp; ADW Wagering.
      </BadgeLegend>
    );
  }
  if (tournament.get("lockdown")) {
    badges.push(
      <BadgeLegend color="orange" icon="key" key="lockdown" text="Lockdown Game">
        All picks must be entered prior to the first race.
      </BadgeLegend>
    );
  }
  if (tournament.get("parent_id")) {
    badges.push(
      <BadgeLegend color="copen-blue" icon="award2" key="qualifier" text="Qualifier Game">
        Qualify for
        {" "}

        <Link to={"/tournaments/" + tournament.get("parent_id")}>
          {tournament.get("parent_name")}
        </Link>
        .
      </BadgeLegend>
    );
  } else if (tournament.get("qualifier")) {
    badges.push(
      <BadgeLegend color="copen-blue" icon="award2" key="qualifier" text="Qualifier Game" />
    );
  }

  return badges;
}
